export default class Perfis {
  constructor({ id, nome, permissoes, acessoLimitadoAnoCursoTurmaDisciplina }) {
    this.id = id;
    this.nome = nome;
    this.permissoes = permissoes;
    this.acessoLimitadoAnoCursoTurmaDisciplina = acessoLimitadoAnoCursoTurmaDisciplina;
  }
}
